/*
 * @Author: Json Chen
 * @Date: 2021-06-08 14:22:55
 * @LastEditTime: 2021-07-06 18:04:45
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/layout/SalesChannelEditorLayout/HomeLayout/HomeLayout.tsx
 */
/**
 *  Layout component for sales channel home editor.
 *  Author: Chris Hao
 *  CreatedAt: 2021-03-04
 */

import React from 'react';
import ResizePanel from 'react-resize-panel';

import * as CSS from 'csstype';

import css from './HomeLayout.less';

interface IProps {
  className?: string;
  style?: CSS.Properties;
  leftChild: React.ReactNode;
  rightChild: React.ReactNode;
  hideRight?: boolean;
  hideLeft?: boolean;
}

const HomeLayout = ({
  className,
  leftChild,
  rightChild,
  style = {},
  hideRight,
  hideLeft,
}: IProps) => {
  return (
    <div className={`${css.container} ${className || ''}`}>
      {!hideLeft && <div className={css.left}>{leftChild}</div>}

      {!hideRight && (
        <ResizePanel
          direction='w'
          style={{
            width: 360,
            minWidth: 360,
            height: '100%',
          }}
          handleClass={css.customHandle}
          borderClass={css.customResizeBorder}>
          <div className={css.right}>{rightChild}</div>
        </ResizePanel>
      )}
    </div>
  );
};

export default HomeLayout;
